import VSelectCourseVideo from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCourseVideo', VSelectCourseVideo),
};
